/**
 * @ngdoc Service
 * @name Alerts
 * @description We use a class here so that we can leverage es6 get() syntax to create read only alert scopes.
 * Provides the application with a state of the current alerts for interactions, global system alerts, product level alerts,ect...
 */
export default function Alerts($interval, $q, $http, environment, $timeout) {
  'ngInject';

  let _serverAlertHash,
    _serverAlertIds = [],
    _serverAlertsRequestInProgress,
    _serverAlertInterval,
    _alertState = new Map();

  //Private methods
  let keyAlert = alert => {
    if (!alert.id) {
      let time = new Date().getTime();
      alert.id = `${time}`;
    }
    return alert;
  };

  let validateAlert = alert => {
    if ((!alert.type || !alert.message) && (!alert.template)) {
      return false;
    }
    else {
      return true;
    }
  };

  let ensureRequestFinished = () => {
    return _serverAlertsRequestInProgress === undefined || _serverAlertsRequestInProgress === false;
  };
  /**
   * @name All
   * @description All Alerts
   * @returns Iterator object with all the values of the alert entries.
   */
  this.all = Array.from(_alertState.values());

  /**
   * @name Length
   * @description Length/Size/Count All Alerts
   * @returns {number} of alerts
   */
  Object.defineProperty(this, 'length', {
    get: ()=> {
      return _alertState.size;
    }
  });

  /**
   * @name Add
   * @description Adds alert to the internal alert state.
   * @param alert
   * @param timeout Number of ms to leave the alert up
   * @returns {number} the id of the alert within the alert state.
   */
  this.add = (alert, timeout = undefined) => {
    if (validateAlert(alert)) {
      let keyedAlert = keyAlert(alert);
      _alertState.set(keyedAlert.id, keyedAlert);
      this.all = Array.from(_alertState.values());
      if (timeout) {
        let timeFm = ()=> {
          this.remove(keyedAlert.id);
        };
        $timeout(timeFm, timeout);
      }
      return keyedAlert.id;
    }
  };
  /**
   * @name Remove
   * @description Removes an alert by id.
   * @param id
   * @returns {boolean}
   */
  this.remove = (id) => {
    if (_alertState.has(id)) {
      _alertState.delete(id);
      this.all = Array.from(_alertState.values());
    }
  };
  /**
   * @name Clear
   * @description Clears alerts state
   */
  this.clear = () => {
    _alertState.clear();
  };

  /**
   * @name Get Alerts
   * @description Gets the alerts from the server, ensuring that only one request is going at a time. Updates alert state with results.
   * @returns {*} the resolution of the request.
   * @param context
   */
  this.getAlerts = (context = undefined) => {
    if (ensureRequestFinished()) {
      let defer = $q.defer();
      //Set gaurd var to stop other syncs
      _serverAlertsRequestInProgress = true;
      //Ng resource get
      let req = $http({
        url: `${environment.api.baseUrl}/alerts`,
        params: context ? {context} : undefined
      });
      //Attach to the ng resource promise
      req.then((response) => {
        let responseAlerts = response.data.alerts;
        if (!responseAlerts) $q.reject();
        //Has will be a unique key for the alert payload
        if (_serverAlertHash === undefined || response.data.hash !== _serverAlertHash) {

          //Remove all expired/removed alerts from local server alert store
          _serverAlertIds = _serverAlertIds.filter((id)=> {
            //If the Id doesn't exist
            let notInResponse = responseAlerts.indexOf(id) === -1,
              alert = _alertState.get(id);
            if (notInResponse && alert && !alert.userInteractionRequired) {
              this.remove(id);
              return false;
            }else {
              return !notInResponse;
            }
          });

          //Add/replace alerts
          responseAlerts.map((alert) => {
            _serverAlertIds.push(alert.id);
            this.add(alert);
          });

          _serverAlertHash = response.data.hash;
        }
        _serverAlertsRequestInProgress = false;
      });

      return defer.promise;
    }
    return $q.reject("Request in progress.");
  };

  /**
   * @name Synchronize Alerts
   * @description Create interval for retrieving alerts.
   * @param {int} interval
   * @param context
   */
  this.synchronizeAlerts = (interval, context = undefined) => {
    this.cancelAlertsSync();
    _serverAlertInterval = $interval(this.getAlerts, interval, 0, false, context);
  };

  /**
   * @name Cancel Alerts Sync
   * @description Stop the alerts interval
   */
  this.cancelAlertsSync = () => {
    if (_serverAlertInterval) {
      $interval.cancel(_serverAlertInterval);
    }
  };

}



/** WEBPACK FOOTER **
 ** ./src/app/services/alerts/alerts.service.js
 **/